import React from "react";
import ContainerCard from "./containerCard";

export default function DataCards({ groups = [] }) {
  return (
    <div className="dataCards">
      <div className="panel">
        {groups.length > 0 &&
          groups.map((entry, i) => (
            <ContainerCard key={i}>
              <div className="card">
                <div className="title">{entry.title}</div>
                <div className={`data data-${i}`}>{entry.data.toLocaleString()}</div>
              </div>
            </ContainerCard>
          ))}
      </div>
    </div>
  );
}
